angular
  .module("newClientInformation.components", [])
  .component("newClientInformation", {
    templateUrl: "ng/components/newClientInformation/newClientInformation.view.html",
    bindings: {
      selectedUser: "=",
      telPrefix: "=",
      onInsert: "&?",
      onNewCustomerSelected: "&?",
      //If true, this wont show CODICE DESTINATARIO, E-MAIL PEC FATTURA, RIFERIMENTO AMMINISTRATIVO
      showElectronicInvoicing: "<",
      isFinancial: "@",
      onBack: "&?",
      onPressInsert: "&?",
      loading:"<"
    },
    controllerAs: "ClientInformationCtrl",
    controller: function ClientInformationController(validationService, $searchUserService, $scope) {
      var self = this;

      self.validationService = validationService;
      self.$searchUserService = $searchUserService;
      self.selected = false;

      self.$onInit = function onInit() {
        self.selectedUser = self.selectedUser || null;
        self.telPrefix = self.telPrefix || null;
        self.onInsert = self.onInsert || null;
        self.showElectronicInvoicing = !!self.showElectronicInvoicing;
      };

      self.$postLink = function(){
         console.log('client information :: postLink!');
      }

      self.insertNewCustomer = function () {
        if (self.isUserFormValid() && self.onInsert) {
           //If it is financial, insert the customer and return the callback
          if(!!self.isFinancial){
            self.onInsert();
          }
        } else {
          console.log("userForm is not valid!");
        }
      };

      self.onClickBack = function () {
        if (self.selected) {
          self.selected = false;
        }else{
         self.onBack();
        }
      };

      self.onSelect = function() {
        self.selected = true;
      }

      /**
       * Private stuff
       */
      self.isUserFormValid = function isUserFormValid() {
        if(!self.selectedUser) return false;

        /**
         * Check showElectronicInvoicing fields
         */
        if(self.showElectronicInvoicing){
           if(!self.selectedUser.metadata.riUserG.fatturazione.fatturazioneElettronica.riferimentoAmministrativo
               || !self.selectedUser.metadata.riUserG.fatturazione.fatturazioneElettronica.emailFatturazioneElettronica
               || !validationService.isValidEmail(self.selectedUser.metadata.riUserG.fatturazione.fatturazioneElettronica.emailFatturazioneElettronica)
               || !self.selectedUser.metadata.riUserG.fatturazione.fatturazioneElettronica.cdDestinatarioFatturazione){
               return false;
           }
        }

        /**
         * check basic fields
         */
         var checkTel="";
         if(self.telPrefix && self.selectedUser.phone){
           checkTel=self.telPrefix.concat(self.selectedUser.phone);
         }
   
         if (
          (!self.selectedUser.identifier ||
          !self.selectedUser.ragSoc ||
          !self.selectedUser.email ||
          !validationService.isValidEmail(self.selectedUser.email) ||
          $scope.userForm.$invalid)
        ){
          return false;
        }
        return true;
      };
      
    }
  });